<script setup>
import HobiesHeading from "@/views/event-activities/components/HobiesHeading.vue";
import HobbiesContent from "@/views/event-activities/components/HobbiesContent.vue";
import {getCurrentInstance, onMounted, reactive} from "vue";
const { $axios } = getCurrentInstance().appContext.config.globalProperties;
const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
const hobbiesPageData = reactive({});

onMounted(()=>{
  $axios.get($endpoint.LoadHobbies).then((resp_hobbies_data)=>{
    Object.assign(hobbiesPageData, resp_hobbies_data.data);
  });
  console.log(hobbiesPageData);
})
</script>

<template>
<HobiesHeading v-if="hobbiesPageData && hobbiesPageData?.activityHero" :slide-items="hobbiesPageData?.activityHero"></HobiesHeading>
  <hobbies-content v-if="hobbiesPageData && hobbiesPageData?.activities" :activities="hobbiesPageData?.activities" ></hobbies-content>
</template>

<style scoped>

</style>